import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-clients-icon',
  templateUrl: './clients-icon.component.html',
  styleUrls: ['./clients-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientsIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
